import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const TAXORA_PRESET = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          500: 'var(--taxora-surface-action)',
        },
        text: {
          color: 'var(--taxora-text-primary)',
          secondaryColor: 'var(--taxora-text-secondary)',
        },
        surface: {
          0: 'var(--taxora-white)',
        },
      },
    },
  },
});
